<span class="alert alert-info" [class._noSpace]="noSpace" [class._hollow]="hollow"> <ng-content></ng-content></span>
